
import React, { forwardRef, useState } from "react";
import "../RussianPoker/Sliderbar.css";

const ProgressSlider = forwardRef((props, ref) => {

    const min = Number(props.mininsurencebet);
    const max = Number(props.maxinsurencebet);

    // ✔ Auto-detect decimal precision from MIN
    const getDecimalCount = (num) => {
        if (Math.floor(num) === num) return 0;
        return num.toString().split(".")[1].length;
    };

    const decimalCount = getDecimalCount(min);
    const step = decimalCount > 0 ? Number("0." + "0".repeat(decimalCount - 1) + "1") : 1;

    const [value, setValue] = useState(min);

    const percent = ((value - min) / (max - min)) * 100;

    const updateValue = (newVal) => {
        const numericVal = Number(newVal);
        setValue(numericVal);

        if (props.onValueChange) {
            props.onValueChange(numericVal);
        }
    };

    // ✔ Button scale animation
    const animateBtn = (selector) => {
        const btn = document.querySelector(selector);
        if (!btn) return;

        btn.classList.remove("btn-click-animate");
        void btn.offsetWidth; // restart animation
        btn.classList.add("btn-click-animate");

        setTimeout(() => {
            btn.classList.remove("btn-click-animate");
        }, 200);
    };

    const decrement = () => {
        const newVal = Math.max(min, value - step);
        updateValue(Number(newVal).toFixed(decimalCount));
        animateBtn(".btnsliderrussiande");
    };

    const increment = () => {
        const newVal = Math.min(max, value + step);
        updateValue(Number(newVal).toFixed(decimalCount));
        animateBtn(".btnsliderrussian");
    };

    return (
        <div className="slider-container">
            <h3 className="valueheading">{Number(value).toFixed(decimalCount)}</h3>

            <div className="controls">

                <div className="decrecontainer" onClick={decrement}>
                    <button className="btnsliderrussiande">−</button>
                </div>

                <input
                    type="range"
                    min={min}
                    max={max}
                    step={step}
                    value={value}
                    onChange={(e) => updateValue(e.target.value)}
                    className="advanced-slider"
                    style={{
                        background: `linear-gradient(90deg, #00c6ff ${percent}%, #2b2b2b ${percent}%)`,
                    }}

                    // ✔ Fix portrait dragging
                    onTouchStart={(e) => e.stopPropagation()}
                    onTouchMove={(e) => e.stopPropagation()}
                    onTouchEnd={(e) => e.stopPropagation()}
                />

                <div className="increcontainer" onClick={increment}>
                    <button className="btnsliderrussian">+</button>
                </div>

            </div>
        </div>
    );
});

export default ProgressSlider;

